import Axios from 'axios';
import { getDeviceType } from '../utils/StatsUtils';
import { CIVITFUN_METRICS_CHECKIN_SESSION, HB_SESSION, getCookie } from '../utils/cookies';
import { CHANNEL_KEY } from '../utils/constants';

export default {
  host: process.env.API,
  upsellHost: process.env.UPSELL_API,
  crossSellHost: process.env.CROSS_SELL_API,
  guestlinkHost: process.env.GUESTLINK_API,
  URIs: {
    chainLanguages: '/checkin/v1/:chainId/chain-languages',
    hotelLanguages: '/checkin/v1/:hotelId/available-languages',
    chainHotels: '/checkin/v1/:chainId/chain-hotels',
    bookingSearchForm: '/checkin/v1/:hotelId/booking-search-form',
    bookingSearch: '/checkin/v2/:hotelId/booking-search',
    startCheckin: '/checkin/v2/:hotelId/start-checkin',
    guestForm: '/checkin/v2/:hotelId/guest-form',
    uploadDocument: '/checkin/v1/:hotelId/upload-document',
    guestData: '/checkin/v1/:hotelId/guest-data',
    bookingCharges: '/payment/v1/:hotelId/booking-charges',
    guestSignature: '/checkin/v1/:hotelId/guest-signature',
    guestSurvey: '/checkin/v1/:hotelId/checkin-survey',
    postSurveyData: '/checkin/v1/:hotelId/checkin-survey-data',
    guestUpsell: '/checkin/v1/:hotelId/upsell-options',
    postUpsell: '/checkin/v1/:hotelId/upsell-add',
    confirmCheckin: '/checkin/v1/:hotelId/checkin-confirm',
    finalizeCheckin: '/checkin/v1/:hotelId/checkin-finalize',
    literals: '/language/v1/texts/:language/',
    chainConf: '/checkin/v1/:chainId/chainConf',
    hotelConf: '/checkin/v1/:hotelId/hotelConf',
    kioskLogin: '/kiosk/v1/login',
    kioskBookingsOfDay: '/kiosk/v1/:hotelId/bookings-of-day-search',
    aliceUserToken: '/checkin/v1/:hotelId/ocr-user-token',
    aliceUserData: '/checkin/v1/:hotelId/ocr-user-data',
    civitfunOcrUserData: '/checkin/v2/:hotelId/ocr-user-data',
    roomUpgradeOptions: '/checkin/v1/:hotelId/room-upgrade-options',
    roomUpgradeAdd: '/checkin/v1/:hotelId/room-upgrade-add',
    restartCheckinStat: '/stats/v1/restart-checkin-stat',
    bookingStatus: '/checkin/v1/:hotelId/booking-status',
    checkout: {
      bookingSearchForm: '/checkout/v1/:hotelId/booking-search-form',
      bookingSearch: '/checkout/v1/:hotelId/booking-search',
      startCheckout: '/checkout/v1/:hotelId/start-checkout',
      checkoutCharges: '/checkout/v1/:hotelId/checkout-charges',
      checkoutFinalize: '/checkout/v1/:hotelId/checkout-finalize',
    },
    upsell: {
      roomUpsellOptions: '/rooms/:roomId/upsell', // ?hotelId
      roomUpsellDetail: '/rooms/:roomId', // ?hotelId
      createUpsell: '/upsells', // ?hotelId
      configureUpsellCharges: '/payment/v1/:hotelId/upsell-configure-charges',
      upsellAddPMSNote: '/checkin/v1/:hotelId/upselling-pms-note',
      upsellNotifyHotelNewRequest: '/booking/upsell',
    },
    crossSell: {
      crossSellOptions: '/items', // ?hotelId
      crossSellDetail: '/items/:itemId', // ?hotelId
      createCrossSell: '/cross-sells', // ?hotelId
      configureCrossSellCharges: '/payment/v1/:hotelId/cross-sell-configure-charges',
      crossSellAddPMSNote: '/checkin/v1/:hotelId/upselling-pms-note',
      crossSellNotifyHotelNewRequest: '/booking/cross-sell',
    },
  },

  setUpInterceptors: () => {
    Axios.interceptors.request.use(
      request => {
        if (typeof window !== 'undefined') {
          const kioskToken = localStorage.getItem('login-token');
          if (kioskToken) request.headers['login-token'] = kioskToken;

          const partner = localStorage.getItem('partner');
          if (partner) request.headers['partner'] = partner;

          const deviceType = getDeviceType();
          if (deviceType) request.headers['device'] = deviceType;

          const cfSession = localStorage.getItem('cf-session');
          if (cfSession) request.headers['cf-session'] = cfSession;

          const cfBooking = localStorage.getItem('cf-booking');
          if (cfBooking) request.headers['cf-booking'] = cfBooking;

          // iframe check
          const isIFrame = window.parent !== window || window != window.top;
          if (isIFrame) request.headers['iframe-embedded'] = true;

          const hbSession = getCookie(HB_SESSION);
          if (hbSession) request.headers['hb-session'] = hbSession;

          const cfmSession = getCookie(CIVITFUN_METRICS_CHECKIN_SESSION);
          if (cfmSession) request.headers[CIVITFUN_METRICS_CHECKIN_SESSION] = cfmSession;

          const metricOrigin = localStorage.getItem('metric-origin');
          if (metricOrigin) request.headers['metric-origin'] = metricOrigin;

          const channel = localStorage.getItem(CHANNEL_KEY);
          if (channel) request.params = { ...request.params, channel: channel };
        }

        return request;
      },
      error => {
        return error;
      }
    );

    Axios.interceptors.response.use(
      response => {
        if (typeof window !== 'undefined') {
          const cfSessionHeader = response.headers['cf-session'];
          if (cfSessionHeader) localStorage.setItem('cf-session', cfSessionHeader);
        }

        return response;
      },
      error => {
        return Promise.reject(error);
      }
    );
  },
};
